import { HttpRequestMethod } from './http-request-method';
import { HttpResponseContent } from './http-response-content.enum';
import { HttpQueryParameter } from './http-query-parameter';
import { HttpMediaType } from './http-media-types';
import { environment } from '../../../../environments/environment';

export class HttpRequest {
  private _authenticated = false;
  private _method: HttpRequestMethod | string = HttpRequestMethod.GET;
  private _contentType: HttpMediaType | string | null = null;
  private _acceptType: HttpMediaType | string | null = null;
  private _responseType: string = HttpResponseContent.Json.toString();
  private _body: any;
  private _queryParameteres = new Array<HttpQueryParameter>();
  private _headers = new Array<[string, string]>();

  constructor(private _url: string) {}

  /**
   * Append path to request url.
   * Path is appended only if not null, empty or unasigned.
   * Path part is normalized, trailing '/' is appended if nedded.
   */
  path(part: string | number | boolean): HttpRequest {
    if (typeof part === 'string' && !this.isEmpty(part)) {
      this._url += this.normalizePathPart(part);
    } else if (typeof part === 'number') {
      this._url += this.normalizePathPart(part);
    } else if (typeof part === 'boolean') {
      this._url += this.normalizePathPart(part);
    }

    return this;
  }

  header(key: string, value: string): HttpRequest {
    if (this.isEmpty(key) || this.isEmpty(value)) {
      // TODO report invalid header
      return this;
    }

    const existing = this._headers.findIndex(
      (h: [string, string]) => h[0] === key
    );

    if (existing > -1) {
      this._headers.splice(existing, 1);
    }

    this._headers.push([key, value]);
    return this;
  }

  contentType(contentType: HttpMediaType): HttpRequest {
    this._contentType = contentType;
    return this;
  }

  acceptType(acceptType: HttpMediaType): HttpRequest {
    this._acceptType = acceptType;
    return this;
  }

  responseType(responseType: HttpResponseContent | string): HttpRequest {
    this._responseType = responseType;
    return this;
  }

  authenticated(authenticated: boolean = environment.isSecure): HttpRequest {
    this._authenticated = authenticated;
    return this;
  }

  method(method: HttpRequestMethod): HttpRequest {
    this._method = method;
    return this;
  }

  query(key: string, value: string | number | boolean): HttpRequest {
    if (
      key === null ||
      key === undefined ||
      key.length === 0 ||
      value === undefined ||
      value === null
    ) {
      return this;
    }

    if (typeof value === 'string' && value.length > 0) {
      this._queryParameteres.push(new HttpQueryParameter(key, value));
    } else if (typeof value === 'boolean') {
      this._queryParameteres.push(new HttpQueryParameter(key, String(value)));
    } else if (typeof value === 'number') {
      this._queryParameteres.push(new HttpQueryParameter(key, String(value)));
    }

    return this;
  }

  body(body: any): HttpRequest {
    this._body = body;
    return this;
  }

  getContentType(): HttpMediaType | string | null {
    return this._contentType;
  }

  getAcceptType(): HttpMediaType | string | null {
    return this._acceptType;
  }

  getResponseType(): string {
    return this._responseType;
  }

  isAuthenticated(): boolean {
    return this._authenticated;
  }

  getUrl(): string {
    return this._url;
  }

  getBody(): any {
    return this._body;
  }

  getMethod(): HttpRequestMethod | string {
    return this._method;
  }

  getQueryParameters(): HttpQueryParameter[] {
    return this._queryParameteres;
  }

  getHeaders(): [string, string][] {
    return this._headers;
  }

  private normalizePathPart(part: string | number | boolean): string {
    if (!this._url.endsWith('/') && !`${part}`.startsWith('/')) {
      return `/${part}`;
    }

    return `${part}`;
  }

  private isEmpty(parameter: string | boolean | number): boolean {
    if (parameter == null || parameter === undefined || parameter === '') {
      return true;
    }
    return false;
  }
}
